var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58.208mm",
    height: "58.208mm",
    viewBox: "0 0 58.208 58.208",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.104,
    cy: 29.104,
    rx: 29.104,
    ry: 29.104,
    fill: "#bfbfff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.95543 0 0 1.0825 -52.005 -113.45)",
    d: "m73.815 124.35c-2.7337-3.2206 0.12791-7.9736 2.9137-10 10.072-7.3277 23.482 1.1689 29.104 10",
    stroke: "#fff",
    strokeWidth: 9.8328
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-.95543 0 0 -1.0825 110.38 171.66)",
    d: "m73.815 124.35c-2.7337-3.2206 0.12791-7.9736 2.9137-10 10.072-7.3277 23.482 1.1689 29.104 10",
    stroke: "#fff",
    strokeWidth: 9.8328
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-.95543 0 0 -1.0825 105.68 171.07)",
    d: "m73.815 124.35c-2.7337-3.2206 0.12791-7.9736 2.9137-10 10.072-7.3277 23.482 1.1689 29.104 10",
    stroke: "#bfbfff",
    strokeWidth: 4.9164
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.95543 0 0 1.0825 -46.851 -111.89)",
    d: "m73.815 124.35c-2.7337-3.2206 0.12791-7.9736 2.9137-10 10.072-7.3277 23.482 1.1689 29.104 10",
    stroke: "#bfbfff",
    strokeWidth: 4.9164
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.104,
    cy: 29.104,
    rx: 6.6145,
    ry: 6.6146,
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0.11
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.479b051648befd4c60d1b233aed3adbb.svg";
export { ForwardRef as ReactComponent };